export default __webpack_public_path__ + "static/media/HomeDepot.de06e86d.svg";